import React, { PureComponent } from 'react';
import { Link, Redirect } from 'react-router-dom';
import strings from 'helper/localization/localization';

export default class Navigation extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loggedOut: false,
    };

    // Properties
    this.logout = this.props.logout;
    this.tokenLogin = this.props.tokenLogin;
    this.enteredFromWHT = this.props.enteredFromWHT;

    this.logoutUser = this.logoutUser.bind(this);
    this.exitAP = this.exitAP.bind(this);
  }

  logoutUser() {
    this.logout();
    this.setState({ loggedOut: true });
  }

  exitAP(e) {
    e.preventDefault();
    if (this.props.exitSdkAfterSignup) {
      window.location.href = this.props.fromLink;
    } else if (this.props.backToProfileLink) {
      window.location.href = this.props.backToProfileLink;
    }
  }

  render() {
    let backToHearingTest = null;

    if (this.state.loggedOut) {
      return <Redirect to="/" />;
    }

    const logout = !this.tokenLogin && this.props.userLoggedIn ?
      (
        <li className="list-group-item bg-light" data-toggle="collapse" data-target="#navbarCollapse">
          <p className="d-block container text-alternate" onClick={this.logoutUser}>
            {strings.logout}
          </p>
        </li>
      ) : null;

    const loggedInItems = this.props.userLoggedIn ?
      (
        <div>
          <li className="list-group-item bg-light" data-toggle="collapse" data-target="#navbarCollapse">
            <Link to="/" id="nav--home-link">
              {strings.navMyMimiAccount}
            </Link>
          </li>
          <li className="list-group-item bg-light" data-toggle="collapse" data-target="#navbarCollapse">
            <Link to="/account/manage">
              {strings.navManageMyAccount}
            </Link>
          </li>
        </div>
      ) : null;

    const loggedOutItems = !this.props.userLoggedIn ?
      (
        <div>
          <li className="list-group-item bg-light" data-toggle="collapse" data-target="#navbarCollapse">
            <Link to="/login">
              {strings.login}
            </Link>
          </li>
          <li className="list-group-item bg-light" data-toggle="collapse" data-target="#navbarCollapse">
            <Link to="/signup">
              {strings.signUpWithMimi}
            </Link>
          </li>
        </div>
      ) : null;

    const contactUs = this.props.userLoggedIn ?
      (
        <li className="list-group-item bg-light" data-toggle="collapse" data-target="#navbarCollapse">
          <Link to="/contact">
            {strings.contactUs.slice(0, -1)}
          </Link>
        </li>
      ) : null;

    const backToHearingTestString = this.enteredFromWHT ?
      strings.back : strings.backToResults;

    if (this.props.backToProfileLink || this.props.exitSdkAfterSignup) {
      backToHearingTest = (
        <button className="btn btn-link" onClick={this.exitAP}>
          {backToHearingTestString}
        </button>
      );
    }

    return (
      <div className="mb-4">
        <nav className="navbar navbar-light bg-light">
          <div className="navbar-brand">
            <div className="nav-item">
              { backToHearingTest }
            </div>
          </div>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarCollapse"
          >
            <span className="navbar-toggler-icon" />
          </button>
        </nav>
        <div>
          <div className="collapse" id="navbarCollapse">
            <ul className="list-group list-group-flush">
              { loggedInItems }
              { loggedOutItems }
              <li className="list-group-item bg-light" data-toggle="collapse" data-target="#navbarCollapse">
                <a href={strings.privacyPolicyLink} target="_blank" rel="noopener noreferrer">
                  {strings.navPrivacyPolicy}
                </a>
              </li>
              <li className="list-group-item bg-light" data-toggle="collapse" data-target="#navbarCollapse">
                <a href={strings.termsOfUseLink} target="_blank" rel="noopener noreferrer">
                  {strings.navTermsOfUse}
                </a>
              </li>
              { contactUs }
              { logout }
            </ul>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/nav/Navigation.jsx